type ProductManualSourceSetting = {
  has_mansual_source?: {
    status?: boolean
  } | null
  has_manual_source?: {
    status?: boolean
  } | null
}

export function isProductManualSourceEnabled(
  setting?: ProductManualSourceSetting | null
) {
  return (
    setting?.has_mansual_source?.status === true ||
    setting?.has_manual_source?.status === true
  )
}
